import React from 'react'
import AssessmentModule from '../../../layout/AssessmentModule/AssesmentModule'
import { Route, Routes, useNavigate, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import AlertSaveButton from '../../../button/AlertSaveButton'
import List from './List/List'
import Create from './Create/Create'
import SelectCurriculum from '../../../SelectCurriculum/SelectCurriculum'
import Edit from './Edit/Edit'
import { updateLearningContinuumForm } from '../../../../store/actions/learning-continuum.actions'
import Module from '../../../layout/Module'
import NotFoundPage from '../../../NotFoundPage/NotFoundPage'

const LearningContinuum = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const params = useParams()
  const curriculumId = params['*']?.split('/')[0]
  const permissions = useSelector((state) => state?.session?.permissions?.lc || {})

  const onRedirect = (redirectTo) => {
    navigate(`/dashboard/learning-continuum/${curriculumId}${redirectTo}`)
  }

  return (
    <AssessmentModule
      moduleName="lc"
      title="Learning Continuum"
      titleLink="/dashboard/learning-continuum"
      actions={<>
        { permissions?.created && curriculumId && (
          <AlertSaveButton
            submodule='Learning Continuum'
            icon='th-list'
            title='List'
            color='secondary'
            onDontSave={() => {
              onRedirect('')
            }}
          />
        )}
        { permissions?.created && curriculumId && (
          <AlertSaveButton
            submodule='Learning Continuum'
            icon='plus'
            title='Create'
            color='secondary'
            onDontSave={() => {
              dispatch(updateLearningContinuumForm({ curriculumId: curriculumId }))
              onRedirect('/create/step/0')
            }}
          />
        )}
      </>}
    >
      <Routes>
        <Route path="/" element={<SelectCurriculum />} />
        <Route index path="/:curriculumId" element={<List />} />
        <Route path="/:curriculumId/create/step/:step" element={<Create />} />
        <Route path="/:curriculumId/edit/:id/step/:step" element={<Edit />} />
        <Route
          path='*'
          element={
            <Module.BodyFullContainer className='flex justify-center items-center'>
              <NotFoundPage />
            </Module.BodyFullContainer>
          } 
        />
      </Routes>
    </AssessmentModule>
  )
}

export default LearningContinuum